import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "dialog", "error", "save"]

  open(event) {
    if (event.target.closest("a, button, input, select, i")) return
    if (window.getSelection().toString()) return

    this.load(event.params.url, event.params.row)
  }

  edit(event) {
    event.preventDefault()
    this.load(event.params.url, event.params.row)
  }

  async load(url, rowId) {
    const response = await fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
    if (!response.ok) {
      window.location = url
      return
    }

    this.rowId = rowId
    this.dialogTarget.innerHTML = await response.text()
    this.initializeFields()
    window.jQuery(this.modalTarget).modal("show")
  }

  async submit(event) {
    event.preventDefault()
    const form = event.target
    this.saveTarget.disabled = true
    this.errorTarget.hidden = true

    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: new FormData(form),
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })

      if (response.ok) {
        const row = document.getElementById(this.rowId)
        if (row) row.outerHTML = await response.text()
        window.jQuery(this.modalTarget).modal("hide")
      } else {
        const data = await response.json().catch(() => ({}))
        this.errorTarget.textContent = data.error || "Could not save the changes."
        this.errorTarget.hidden = false
      }
    } finally {
      this.saveTarget.disabled = false
    }
  }

  initializeFields() {
    const $ = window.jQuery
    const views = window.Stonksfolio.Views

    $(this.dialogTarget).find(".js-datepicker").datepicker({
      format: "dd/mm/yyyy",
      todayHighlight: true,
      endDate: "0d",
      autoclose: true
    })
    $(this.dialogTarget).find(".js-security-select").each((_, element) => new views.SecuritySelect({ el: element }))
    $(this.dialogTarget).find(".js-payment-type-select").each((_, element) => new views.PaymentTypeSelect({ el: element }))
  }
}
